// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SearchChats_paper__-rdW5 {
  width: 424px;
  max-width: 100vw;
  border-radius: 10px !important;
  height: min(100vh, 920px);
}

.SearchChats_header__6THch {
  padding: 16px;
  width: 100%;
}
.SearchChats_header__6THch > * {
  width: 100%;
}

.SearchChats_root__HP\\+md {
  height: min(100vh, 920px);
}

.SearchChats_header__6THch {
  flex-shrink: 0;
  position: relative;
}

.SearchChats_content__7ChlI {
  min-height: 1px;
  max-height: 100%;
  flex-grow: 1;
  flex-shrink: 0;
}

.SearchChats_blockHeading__syzVk {
  width: 100%;
  padding: 4px 16px;
  -webkit-user-select: none;
          user-select: none;
  color: #8E8E93;
  background: #F7F7F7;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.SearchChats_chat__content__k95qA {
  color: #8E8E93;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.SearchChats_result__PkSJN {
  height: 100%;
  overflow-y: scroll;
}

.SearchChats_placeholder__ImRM8 {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 15px 0;
}
.SearchChats_placeholder__title__89m5h {
  margin-top: 32px;
  color: #272A36;
  text-align: center;
  font-size: 16px;
  font-weight: 500;
  line-height: 19px;
}
.SearchChats_placeholder__description__MjFht {
  margin-top: 16px;
  color: #272A36;
  text-align: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
}

.SearchChats_body__k3fEl {
  border-top: 1px solid #D9D9D9;
}

.SearchChats_title__Xgn9z {
  color: #272A36;
  font-size: 14px;
  font-weight: 500;
  line-height: 16px;
  margin-bottom: 16px;
}

.SearchChats_close__iVc5O {
  background: transparent;
  border: 0;
  cursor: pointer;
  outline: none;
  position: absolute;
  right: 0;
  top: 0;
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.SearchChats_close__icon__I-9Zw {
  transform: rotate(0deg);
  transition: 0.3s all;
}
.SearchChats_close__iVc5O:hover .SearchChats_close__icon__I-9Zw {
  transform: rotate(180deg);
}

.SearchChats_cleanSearch__FgfMV {
  cursor: pointer;
  border: 0;
  background: transparent;
  height: 100% !important;
  max-height: unset !important;
  padding: 0 5px;
  padding-right: 15px;
  transform: translateX(10px);
  position: absolute;
  top: -1px;
  right: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
}`, "",{"version":3,"sources":["webpack://./src/components/modals/SearchChats/SearchChats.module.scss","webpack://./src/assets/scss/mixins.scss"],"names":[],"mappings":"AAEA;EACE,YAAA;EACA,gBAAA;EACA,8BAAA;EAEA,yBAAA;AAFF;;AAKA;EACE,aAAA;EACA,WAAA;AAFF;AAIE;EACE,WAAA;AAFJ;;AAMA;EAEE,yBAAA;AAJF;;AAaA;EACE,cAAA;EACA,kBAAA;AAVF;;AAaA;EACE,eAAA;EACA,gBAAA;EAEA,YAAA;EACA,cAAA;AAXF;;AAcA;EACE,WAAA;EACA,iBAAA;EACA,yBAAA;UAAA,iBAAA;EAEA,cAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EAEA,mBAAA;EACA,uBAAA;EACA,gBAAA;AAbF;;AAgBA;EACE,cAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EChEA,mBAAA;EACA,gBAAA;EACA,uBAAA;ADoDF;;AAeA;EACE,YAAA;EACA,kBAAA;AAZF;;AAeA;EACE,YAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;AAZF;AAcE;EACE,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AAZJ;AAeE;EACE,gBAAA;EAEA,cAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AAdJ;;AAkBA;EACE,6BAAA;AAfF;;AAkBA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;AAfF;;AAkBA;EACE,uBAAA;EACA,SAAA;EACA,eAAA;EACA,aAAA;EAEA,kBAAA;EACA,QAAA;EACA,MAAA;EAEA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAjBF;AAmBE;EACE,uBAAA;EACA,oBAAA;AAjBJ;AAqBI;EACE,yBAAA;AAnBN;;AAwBA;EACE,eAAA;EACA,SAAA;EACA,uBAAA;EACA,uBAAA;EACA,4BAAA;EAEA,cAAA;EACA,mBAAA;EAEA,2BAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EAEA,aAAA;EACA,mBAAA;EACA,uBAAA;AAxBF","sourcesContent":["@import '@/assets/scss/mixins.scss';\n\n.paper {\n  width: 424px;\n  max-width: 100vw;\n  border-radius: 10px !important;\n\n  height: min(100vh, 920px);\n}\n\n.header {\n  padding: 16px;\n  width: 100%;\n\n  &>* {\n    width: 100%;\n  }\n}\n\n.root {\n  //width: 100%;\n  height: min(100vh, 920px);\n\n  //display: flex;\n  //flex-direction: column;\n  //align-items: stretch;\n  //justify-content: center;\n  //min-height: 1px;\n}\n\n.header {\n  flex-shrink: 0;\n  position: relative;\n}\n\n.content {\n  min-height: 1px;\n  max-height: 100%;\n  //overflow-y: scroll;\n  flex-grow: 1;\n  flex-shrink: 0;\n}\n\n.blockHeading {\n  width: 100%;\n  padding: 4px 16px;\n  user-select: none;\n\n  color: #8E8E93;\n  background: #F7F7F7;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n}\n\n.chat__content {\n  color: #8E8E93;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n\n  @include ellipsis;\n}\n\n.result {\n  height: 100%;\n  overflow-y: scroll;\n}\n\n.placeholder {\n  height: 100%;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  padding: 15px 0;\n\n  &__title {\n    margin-top: 32px;\n    color: #272A36;\n    text-align: center;\n    font-size: 16px;\n    font-weight: 500;\n    line-height: 19px;\n  }\n\n  &__description {\n    margin-top: 16px;\n\n    color: #272A36;\n    text-align: center;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 16px;\n  }\n}\n\n.body {\n  border-top: 1px solid #D9D9D9;\n}\n\n.title {\n  color: #272A36;\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 16px;\n  margin-bottom: 16px;\n}\n\n.close {\n  background: transparent;\n  border: 0;\n  cursor: pointer;\n  outline: none;\n\n  position: absolute;\n  right: 0;\n  top: 0;\n\n  width: 48px;\n  height: 48px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  &__icon {\n    transform: rotate(00deg);\n    transition: 0.3s all;\n  }\n\n  &:hover {\n    & .close__icon {\n      transform: rotate(180deg);\n    }\n  }\n}\n\n.cleanSearch {\n  cursor: pointer;\n  border: 0;\n  background: transparent;\n  height: 100% !important;\n  max-height: unset !important;\n\n  padding: 0 5px;\n  padding-right: 15px;\n\n  transform: translateX(10px);\n  position: absolute;\n  top: -1px;\n  right: 10px;\n\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n","@mixin ellipsis {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n@mixin invisible-scroll {\n  overflow: -moz-scrollbars-none;\n  overflow: -moz-hidden-unscrollable;\n  scrollbar-width: none;\n\n  &::-webkit-scrollbar {\n    display: none;\n    width: 0 !important;\n    -ms-overflow-style: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"paper": `SearchChats_paper__-rdW5`,
	"header": `SearchChats_header__6THch`,
	"root": `SearchChats_root__HP+md`,
	"content": `SearchChats_content__7ChlI`,
	"blockHeading": `SearchChats_blockHeading__syzVk`,
	"chat__content": `SearchChats_chat__content__k95qA`,
	"result": `SearchChats_result__PkSJN`,
	"placeholder": `SearchChats_placeholder__ImRM8`,
	"placeholder__title": `SearchChats_placeholder__title__89m5h`,
	"placeholder__description": `SearchChats_placeholder__description__MjFht`,
	"body": `SearchChats_body__k3fEl`,
	"title": `SearchChats_title__Xgn9z`,
	"close": `SearchChats_close__iVc5O`,
	"close__icon": `SearchChats_close__icon__I-9Zw`,
	"cleanSearch": `SearchChats_cleanSearch__FgfMV`
};
export default ___CSS_LOADER_EXPORT___;
